export default __webpack_public_path__ + "icons/successCircle-ca8751.svg";